import { findLast } from 'lodash';

import { IUserDocument } from '../ts/document';

export const areUserIdentityDocumentsUploaded = (
  userDocuments: IUserDocument[],
): boolean => {
  const identityDocument = findLast(userDocuments, {
    type: 'identity_document',
  });
  const taxNumber = findLast(userDocuments, {
    type: 'tax_number',
  });

  return Boolean(
    identityDocument?.document_front &&
      identityDocument.document_rear &&
      taxNumber,
  );
};
